exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:Disclaimer;src:url(\"https://cdn-cs-awsca.101.com/v0.1/static/app_store_service/aws-california/static/fonts/Disclaimer/Disclaimer-Regular.otf\")}@font-face{font-family:VulfSans;src:url(\"https://cdn-cs-awsca.101.com/v0.1/static/app_store_service/aws-california/static/fonts/VulfSans/VulfSans-Light.otf\")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/application/styles/app.css
// module id = 386
// module chunks = 9